const INTERNAL_FAILURE_CODES_TRANSLATIONS = {
  parcel_not_found: "parcel_not_available",
  open_door_max_tries_exceeded: "max_reopens_exceed",
  retry_max_tries_exceeded: "max_reopens_exceed",
};

export function translateInternalFailureCode(internalFailureCode: string) {
  return (
    INTERNAL_FAILURE_CODES_TRANSLATIONS[internalFailureCode] ||
    internalFailureCode
  );
}
